/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangePasswordDto } from '../models/ChangePasswordDto';
import type { ChangePasswordResponseDto } from '../models/ChangePasswordResponseDto';
import type { ConfirmChangePasswordDto } from '../models/ConfirmChangePasswordDto';
import type { CreateUserDto } from '../models/CreateUserDto';
import type { ResetPasswordDto } from '../models/ResetPasswordDto';
import type { SetupTotpResponseDto } from '../models/SetupTotpResponseDto';
import type { TokenDto } from '../models/TokenDto';
import type { UpdateSecurityProfileDto } from '../models/UpdateSecurityProfileDto';
import type { UpdateSecurityProfileResponseDto } from '../models/UpdateSecurityProfileResponseDto';
import type { UpdateUserDto } from '../models/UpdateUserDto';
import type { UserDto } from '../models/UserDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class UsersService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @deprecated
     * @param body
     * @returns TokenDto Created
     * @throws ApiError
     */
    public postV1Users(
        body?: CreateUserDto,
    ): CancelablePromise<TokenDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/users',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @deprecated
     * @param id
     * @param body
     * @returns any OK
     * @throws ApiError
     */
    public patchV1Users(
        id: number,
        body?: UpdateUserDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/users/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @deprecated
     * @param id
     * @returns UserDto OK
     * @throws ApiError
     */
    public getV1Users(
        id: number,
    ): CancelablePromise<UserDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @deprecated
     * @param id
     * @param body
     * @returns any OK
     * @throws ApiError
     */
    public putV1UsersPassword(
        id: number,
        body?: ResetPasswordDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/users/{id}/password',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param body
     * @returns ChangePasswordResponseDto OK
     * @throws ApiError
     */
    public putV1UsersChangePassword(
        id: number,
        body?: ChangePasswordDto,
    ): CancelablePromise<ChangePasswordResponseDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/users/{id}/change-password',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param body
     * @returns any OK
     * @throws ApiError
     */
    public putV1UsersChangePasswordTwoFactor(
        id: number,
        body?: ConfirmChangePasswordDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/users/{id}/change-password-two-factor',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @deprecated
     * @param id
     * @param body
     * @returns UpdateSecurityProfileResponseDto OK
     * @throws ApiError
     */
    public patchV1UsersSecurityProfile(
        id: number,
        body?: UpdateSecurityProfileDto,
    ): CancelablePromise<UpdateSecurityProfileResponseDto> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/users/{id}/security-profile',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @deprecated
     * @param customerId
     * @returns SetupTotpResponseDto OK
     * @throws ApiError
     */
    public postV1UsersTotpSetup(
        customerId: number,
    ): CancelablePromise<SetupTotpResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/users/{customerId}/totp-setup',
            path: {
                'customerId': customerId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
